export default "__VITE_ASSET__C$IAshYd__"